import axios from 'axios'
import HTTP from './http'

export default {
    getList: payload => axios.get(HTTP.RIGHTS_LIST, { params: payload }),
    addRight: payload => axios.post(HTTP.RIGHT, payload),
    updateRight: payload => axios.put(HTTP.RIGHT, payload),
    deleteRight: payload => axios.delete(HTTP.RIGHT, { params: { id: payload } })
}
